export function intArray(length) {
    return Array.from({ length: length }, (v, i) => i);
}